// DEPRECATED(formsy-retirement): legacy formsy-react field. Use a Formik-based field instead.
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { withFormsy } from 'formsy-react';
import _ from 'lodash';
import React from 'react';

// TODO: confirm this is still used - see if we can remove it. May need to scan for more orphans like this.
class PasswordBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
  }

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  changeValue = event => {
    const { setValue, passValue } = this.props;
    // get value
    const { value } = event.currentTarget;
    // set Formsy value
    setValue(value);
    // if custom passValue function is passed, give that the value too
    if (typeof passValue === 'function') {
      passValue(value);
    }
  };

  render() {
    const { title, errorMessage, showRequired, value } = this.props;

    const { visible } = this.state;

    // trim some un-needed props as far as passing down
    const trimmedProps = _.pick(
      this.props,
      'fullWidth',
      'multiline',
      'rows',
      'rowsMax',
      'maxLength',
      'max',
      'min',
      'type',
      'disabled',
    );

    const errorText = errorMessage || (showRequired ? 'This Field is Required' : '');

    return (
      <div style={{ display: 'flex', alignItems: 'flex-end' }}>
        <TextField
          label={title}
          errorText={errorText}
          onChange={this.changeValue}
          value={value}
          type={visible ? 'text' : 'password'}
          sx={{ mr: 1 }}
          {...trimmedProps}
        />
        <div style={{ height: '50px' }}>
          <Button
            variant="contained"
            color="secondary"
            style={{ minWidth: '80px' }}
            onClick={this.toggleVisibility}
            tabIndex={-1}
          >
            {visible ? 'Hide' : 'Show'}
          </Button>
        </div>
      </div>
    );
  }
}

export default withFormsy(PasswordBox);
